import React from "react";
import Modal from "./Modal";
import { Loader2 } from "lucide-react";

const ProcessingModal = ({ isOpen, onClose, progress, totalRows }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Processing Data">
      <div className="flex flex-col items-center py-6">
        <div className="mb-6 relative">
          <Loader2 className="h-12 w-12 text-blue-500 animate-spin" />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-xs font-medium text-blue-900">
              {progress}%
            </span>
          </div>
        </div>

        <div className="w-full bg-blue-100 rounded-full h-2.5 mb-6">
          <div
            className="bg-blue-600 h-2.5 rounded-full transition-all duration-300 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>

        <p className="text-blue-800 text-sm mb-1">
          Processing <span className="font-semibold">{totalRows}</span> rows
        </p>
        <p className="text-blue-600 text-xs">
          Please don't close this window until processing is complete
        </p>
      </div>
    </Modal>
  );
};

export default ProcessingModal;
